<template>
  <span class="ai-save-to-knowledge">
    <Button
      icon="md-folder"
      :disabled="disabled"
      :loading="loading"
      @click="openModal"
    >保存</Button>
    <Modal
      v-model="visible"
      title="保存到个人知识库"
      :loading="loading"
      @on-ok="handleSave"
      @on-cancel="closeModal"
    >
      <div class="ai-save-form-item">
        <label class="ai-save-form-label">选择目录（可选个人根目录）</label>
        <PersonalDirPicker ref="picker" v-model="saveDirId" :allow-create="true" />
      </div>
      <div class="ai-save-form-item">
        <label class="ai-save-form-label">文件名称</label>
        <Input v-model="saveFileNameInput" placeholder="不含扩展名，将保存为 .md" />
      </div>
      <p v-if="saveConflict" class="ai-save-conflict">
        目录中已存在同名文件「{{ saveConflict.name || '同名文件' }}」，保存将覆盖原文件。
      </p>
    </Modal>
  </span>
</template>

<script>
import PersonalDirPicker from '@/components/knowledge/PersonalDirPicker.vue';
import {
  buildDefaultAiSaveName,
  fetchKnowledgeItems,
  findSameNameMdInDir,
  saveMarkdownToKnowledge,
} from '@/components/knowledge/personal-knowledge';

export default {
  name: 'AiSaveToKnowledgeButton',
  components: { PersonalDirPicker },
  props: {
    content: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    fileName: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      visible: false,
      loading: false,
      saveDirId: '',
      saveFileNameInput: '',
      saveConflict: null,
      allKnowledgeItems: [],
    };
  },
  watch: {
    saveFileNameInput(name) {
      this.checkNameConflict(name);
    },
    saveDirId() {
      this.checkNameConflict(this.saveFileNameInput);
    },
  },
  methods: {
    getDefaultSaveName() {
      if (this.fileName && String(this.fileName).trim()) {
        return String(this.fileName).trim();
      }
      return buildDefaultAiSaveName('AI报告');
    },
    async openModal() {
      if (this.disabled) return;
      const text = String(this.content || '').trim();
      if (!text) {
        this.$Message.warning('没有可保存的内容');
        return;
      }
      this.saveFileNameInput = this.getDefaultSaveName();
      this.visible = true;
      try {
        this.allKnowledgeItems = await fetchKnowledgeItems(this.$api);
        this.checkNameConflict(this.saveFileNameInput);
      } catch (err) {
        console.error(err);
      }
    },
    closeModal() {
      this.visible = false;
      this.saveConflict = null;
    },
    checkNameConflict(name) {
      if (!this.saveDirId || !name) {
        this.saveConflict = null;
        return;
      }
      this.saveConflict = findSameNameMdInDir(
        this.allKnowledgeItems,
        this.saveDirId,
        name,
      );
    },
    async handleSave() {
      const content = String(this.content || '').trim();
      if (!content) {
        this.$Message.warning('没有可保存的内容');
        return false;
      }
      if (!this.saveDirId) {
        this.$Message.warning('请选择保存目录');
        return false;
      }
      const name = String(this.saveFileNameInput || '').trim();
      if (!name) {
        this.$Message.warning('请输入文件名称');
        return false;
      }

      this.loading = true;
      try {
        if (!this.allKnowledgeItems.length) {
          this.allKnowledgeItems = await fetchKnowledgeItems(this.$api);
        }
        const conflict = findSameNameMdInDir(this.allKnowledgeItems, this.saveDirId, name);
        await saveMarkdownToKnowledge(this.$api, {
          dirId: this.saveDirId,
          name,
          content,
          overwriteId: conflict && conflict.id,
        });
        this.$Message.success(conflict ? '已覆盖保存' : '已保存');
        this.closeModal();
      } catch (err) {
        console.error(err);
        this.$Message.error('保存失败');
        return false;
      } finally {
        this.loading = false;
      }
      return true;
    },
  },
};
</script>

<style lang="less" scoped>
.ai-save-form-item {
  margin-bottom: 16px;
}
.ai-save-form-label {
  display: block;
  margin-bottom: 6px;
  font-size: 13px;
  color: var(--subtext1);
}
.ai-save-conflict {
  font-size: 12px;
  color: #ed4014;
  margin: 0;
}
</style>
